/**
 * @description
 * Objeto AdministracionRepresenta
 */

export class AdministracionRepresenta {
    public nif:string;
    public nom:string;
  
    constructor() {}
}